export default function()
{
    const self = this;

    /**
     * The window object
     * @type {jQuery}
     */
    self.$window = $(window);

    /**
     * The bar that stays fixed
     * @type {jQuery}
     */
    self.$fixedElement = $('.fixed-header');

    /**
     * The mobile menu
     * @type {jQuery}
     */
    self.$mobileMenu = $('.navbar-collapse');

    /**
     * The mobile menu toggler
     * @type {jQuery}
     */
    self.$mobileMenuToggler = $('.navbar-toggler');

    /**
     * Indicates if the page has been scrolled past the breakpoint
     * @type {Boolean}
     */
    self.pastBreakpoint = false;

    /**
     * Indicates if the styling is applied or not
     * @type {Boolean}
     */
    self.styleApplied = false;

    /**
     * Enable changing the menu styling during scroll
     * @return {void}
     */
    self.enableScrollStyling = () => {
        self.$window.on('load scroll', () => {
            const scrolled = self.$window.scrollTop();

            self.pastBreakpoint = (scrolled >= 5);

            if (self.pastBreakpoint && ! self.styleApplied) {
                self.$fixedElement.addClass('scrolled');
                self.styleApplied = true;
            } else if(! self.pastBreakpoint && self.styleApplied) {
                self.$fixedElement.removeClass('scrolled');
                self.styleApplied = false;
            }
        });
    };
}



// WEBPACK FOOTER //
// ./resources/js/MrMovie/Menu.js